const mutations = {
  SET_TIME_ZONES (state, { time_zones }) {
    state.time_zones = time_zones
  }
}

export default mutations
